import {
  BrowserRouter,
  Navigate,
  Route,
  Router,
  Routes,
  useSearchParams,
} from "react-router-dom";
import "./App.css";
import Main from "./Auth/Main";
import SignIn from "./Auth/SignIn";
import Home from "./Guest/Home";
import Invoice from "./Invoice";
import AdditionalDetails from "./Guest/AdditionalDetails";
import HomePageRes from "./Responsive/HomeBundle/HomePageRes";
import NewParty from "./Responsive/HomeBundle/NewParty";
import { useEffect } from "react";
import NotificationPageRes from "./Responsive/HomeBundle/NotificationPageRes";
import ProfilePage from "./Responsive/HomeBundle/ProfilePage";
import SettingsPage from "./Responsive/HomeBundle/SettingsPage";
import Navigation from "./navigator/Navigation";
import HostPage from "./Responsive/EventBundle/HostPage";
import SpotifyPlaylistPage from "./playlist/SpotifyPlaylistPage";
import SearchPage from "./Responsive/HomeBundle/SearchPage";
import GuestStatus from "./Responsive/HomeBundle/GuestStatus";
import AddGuestPage from "./Responsive/HomeBundle/AddGuestPage";
import { auth, provider, providerApple } from "./Auth/config";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import QRCodeScreen from "./Responsive/EventBundle/QRCodeScreen";
import ComingSoonPageRes from "./Responsive/HomeBundle/ComingSoonPageRes";
import PhoneAuth from "./Auth/Box/PhoneAuth";
import PhoneAuth2 from "./Auth/Box/PhoneAuth2";
import { getUserFirebase } from "./Api/data";
import { getUserData } from "./Api/firebaseAPis";
import { getAllfollowfollower, getAllfollowfollowing } from "./Api/firestoreApis";
import FollowerAndFollowingUpload from "./scripts/FollowerAndFollowingUpload";

import Follower from "./Responsive/Components/Follower";
import Following from "./Responsive/Components/Following";

import SpotifyAuth from "./playlist/SpotifyAuth";


function App() {
  const isLoggedIn = useSelector((state) => state.Auth).isLoggedIn;
  const showNavigator = useSelector((state) => state.Auth).showNavigator;
  const phoneNumber = useSelector((state) => state.Auth).phoneNumber;
  const dispatch = useDispatch();
  const [showPhoneAuth, setShowphoneAuth] = useState(false);
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => {
    var date = new Date();

    const arrayMonths = ["jan", "feb", "mar", "apri", "may", "june", "july"];

    const loginStatus = localStorage.getItem("uid");
    if (loginStatus) {
      dispatch({
        type: "SET_LOGGED_IN",
        isLoggedIn: true,
      });
    }
  }, []);


  async function Allfollowing() {
    let userid = localStorage.getItem('uid');
    let allfollowingdata = await getAllfollowfollowing(userid)
    let allfollowerdata = await getAllfollowfollower(userid)
    
    if (localStorage.getItem("uid")) {
      let datadfg = await getUserData(localStorage.getItem("uid"));

      dispatch({
        type: "USER_DATA",
        allUserData: datadfg,
      });
    }

    dispatch({
      type: "FOLLOWING_DATA",
      followingData: allfollowingdata,
    });

    dispatch({
      type: "FOLLOWER_DATA",
      allfollowerdata: allfollowerdata,
    });
  }

  useEffect(() => {
    Allfollowing()
  }, [])

  const requireLogin = (nextState, replace, cb) => {
    function checkAuth() {
      const user = auth.onAuthStateChanged((user) => user); // check login in your state
      if (!user) {
        replace("/"); // make user to redirect to some route based on your requirement
      }
      cb(); //if user present in it fallback to here
    }
  };
  // const location = useNavigation();
  useEffect(() => {
    get_user_data();
  }, [isLoggedIn]);

  useEffect(() => {
    const phonestatus = localStorage.getItem("phone");
    if (phonestatus !== null) {
      dispatch({
        type: "SET_PHONENUMBER",
        phoneNumber: phonestatus,
      });
    }
  }, [phoneNumber]);

  const get_user_data = async () => {
    let data = await getUserData(localStorage.getItem("uid"));
    if (
      !Object.keys(data).includes("username") ||
      !Object.keys(data).includes("dob") ||
      !Object.keys(data).includes("gender")
    ) {
      setShowAdd(true);
    } else {
      setShowAdd(false);
    }

    if (Object.keys(data).includes("phoneDetails")) {
      setShowphoneAuth(false);
    } else {
      setShowphoneAuth(true);
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
        <Route path='/spotify-playlist' element={<SpotifyPlaylistPage/>} />
        <Route path='/spotify-auth' element={<SpotifyAuth/>} />
          {isLoggedIn ? (
            <>
              (
              <>
                <>
                  <Route path="/add" element={<AdditionalDetails />} />
                  <Route path="/home" element={<HomePageRes />} />
                 
                  <Route path="/" element={<HomePageRes />} />
                  <Route
                    path="/create-event"
                    element={
                      <ComingSoonPageRes
                        text={
                          "Want to throw a party with Surge? Download the app and throw the best party ever with us!"
                        }
                      />
                    }
                  />
                  <Route
                    path="/notifications"
                    element={<NotificationPageRes />}
                  />
                  <Route path="/profile-page" element={<ProfilePage />} />
                  <Route path="/follower" element={<Follower />} />
                  <Route path="/following" element={<Following />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/event" element={<HostPage />} />
                  <Route
                    path="/playlist-page"
                    element={
                      <ComingSoonPageRes
                        text={
                          "Want to listen to your favorite songs at the party? Download Surge to upload playlists from Spotify or Apple Music to your next event and party like a rock star!"
                        }
                      />
                    }
                  />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/guest-info" element={<GuestStatus />} />
                  <Route path="/invite-guests" element={<AddGuestPage />} />
                  <Route path="/qr" element={<QRCodeScreen />} />
                  

                  <Route
                    path="/comingsoon"
                    element={
                      <ComingSoonPageRes
                        text={
                          "For additional features, download Surge and throw authentic parties!"
                        }
                      />
                    }
                  />
                </>
              </>
              )
            </>
          ) : (
            <>

              <Route path="*" element={<PhoneAuth2 />} />
              <Route path="/event" element={<HostPage />} />
            </>
          )}
        </Routes>
        {isLoggedIn && showNavigator ? <Navigation /> : <></>}
      </BrowserRouter>
    </div>
  );
}

export default App;